"use client";

import type { TabellenDichte } from "./tabellen-typen";

const KNOPF =
  "py-2 px-3 -ms-px first:rounded-s-lg first:ms-0 last:rounded-e-lg inline-flex items-center gap-x-2 text-sm font-medium focus:z-10 bg-layer border border-layer-line text-layer-foreground shadow-2xs hover:bg-layer-hover focus:outline-hidden focus:bg-layer-focus disabled:opacity-50 disabled:pointer-events-none";
const KNOPF_AKTIV =
  "py-2 px-3 -ms-px first:rounded-s-lg first:ms-0 last:rounded-e-lg inline-flex items-center gap-x-2 text-sm font-medium focus:z-10 bg-layer-active border border-layer-line text-layer-foreground shadow-2xs hover:bg-layer-hover focus:outline-hidden focus:bg-layer-focus disabled:opacity-50 disabled:pointer-events-none";

/**
 * Dichte-Umschalter „Standard / Kompakt“ (T15, wie `DichteUmschalter` auf /heute, Entscheid 05.10.): kontrolliert,
 * ohne Speichern. Der Aufrufer legt den Wert je Person ab (z. B. `user_preferences`) und reicht ihn an die Tabelle weiter.
 */
export function DichteWahl({ dichte, onWechsel }: { dichte: TabellenDichte; onWechsel: (neu: TabellenDichte) => void }) {
  return (
    <>
      {/* Preline: component/button-group/button-group-small */}
      <div className="inline-flex rounded-lg shadow-2xs" role="group" aria-label="Zeilendichte der Tabelle">
        <button type="button" className={dichte === "standard" ? KNOPF_AKTIV : KNOPF} aria-pressed={dichte === "standard"} onClick={() => onWechsel("standard")}>
          Standard
        </button>
        <button type="button" className={dichte === "kompakt" ? KNOPF_AKTIV : KNOPF} aria-pressed={dichte === "kompakt"} onClick={() => onWechsel("kompakt")}>
          Kompakt
        </button>
      </div>
    </>
  );
}
